"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whitelistTransform = void 0;
/**
 * Extract whitelist array.
 */
function whitelistTransform(whitelistObject) {
    return whitelistObject && whitelistObject.whitelist;
}
exports.whitelistTransform = whitelistTransform;
